import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import IntegrationBenefits from "./IntegrationBenefits";
import ConnectWithMailchimp from "./ConnectWithMailchimp";
import Uninstall from "./Uninstall";
import { SiMailchimp } from "react-icons/si";
import {
  ClassNames,
  getCookie,
  // getDataFromDb,
  // updateDataInDb,
} from "../../../../helper";
import { FaAngleLeft } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { getDataFromMongoDb, updateDataInMongoDb } from "../../../../services/mongod.data";
const CF_MailChimp_API_URL =
  "https://us-central1-causalfunnel-21.cloudfunctions.net/CF_MailChimp_Server";
const MailChimp = () => {
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
  const [accessToken, setAccessToken] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const mailchimpAuthCode = queryParams.get("code");
  const [install, setInstall] = useState(false);
  const [integration, setIntegration] = useState(false);
  const [integrationData, setIntegrationData] = useState({});
  const [open, setOpen] = useState(false);

  const installHandler = (state) => setInstall(state);

  useEffect(() => {
    if (!integration) setIntegrationData({});
  }, [integration]);

  useEffect(() => {
    if (!mailchimpAuthCode) return;
    const fetchData = async () => {
      try {
        // console.log("mailchimpAuthCode", mailchimpAuthCode);
        const postData = {
          code: mailchimpAuthCode,
        };
        const response = await axios.post(CF_MailChimp_API_URL, postData);
        const { access_token } = response.data;
        // console.log("Response:", response.data);
        if (access_token) {
          setAccessToken(access_token);
          // let api_url = `${user}/graph-integration/mailchimp`;
          // updateDataInDb(api_url, response.data);
          await updateDataInMongoDb(user, "graph-integration", ["mailchimp" ],  response.data);
          setIntegration(true);
          navigate({ replace: true, search: "" });
        }
      } catch (error) {
        console.error("Error:", error.message);
      }
    };

    fetchData();
  }, [mailchimpAuthCode]);

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;
      try {
        // let api_url = `${user}/graph-integration/mailchimp`;
        // let result = await getDataFromDb(api_url);
        let apiData = await getDataFromMongoDb(user, "graph-integration");
        let result = apiData.data.mailchimp || apiData.data.data.mailchimp;
        // console.log("mailchimp result GET", result);
        if (result) {
          setIntegration(true);
          setIntegrationData(result);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [user]);

  return (
    <div className="bg-gray-200 w-full p-3 relative">
      <NavLink
        to="/integration"
        className="text-indigo-600 text-lg text-semibold flex gap-1 items-center "
      >
        <FaAngleLeft className="text-sm" />
        Go back
      </NavLink>
      <div className="bg-white  p-4 rounded-md my-3">
        <header className="flex justify-between items-center border-bottom">
          <div className="my-3 flex items-center gap-3">
            <SiMailchimp className="text-3xl text-gray-500" />
            <p className="text-lg font-semibold">Mailchimp</p>
          </div>
          {integration && !install ? (
            <div className="space-x-2">
              <button
                className={ClassNames(
                  "text-gray-700 border p-1.5 rounded-md px-3.5 hover:cursor-pointer hover:bg-gray-100"
                )}
                onClick={() => setOpen(true)}
              >
                Uninstall
              </button>
              <button
                className={ClassNames(
                  "text-indigo-700 bg-indigo-200 p-1.5 rounded-md px-3.5 hover:bg-indigo-300 hover:cursor-pointer"
                )}
                onClick={() => setInstall(true)}
              >
                Configure
              </button>
            </div>
          ) : (
            <button
              className={ClassNames(
                "text-white bg-indigo-600 p-1.5 rounded-md px-3.5 hover:bg-indigo-500 hover:cursor-pointer",
                install ? "hidden" : ""
              )}
              onClick={() => setInstall(true)}
            >
              Install Mailchimp
            </button>
          )}
        </header>
        {install ? (
          <ConnectWithMailchimp
            installHandler={installHandler}
            integrationData={integrationData}
          />
        ) : (
          <div className="relative">
            <Uninstall
              open={open}
              setOpen={setOpen}
              setIntegration={setIntegration}
            />
            <IntegrationBenefits />
          </div>
        )}
      </div>
    </div>
  );
};

export default MailChimp;
